export default __webpack_public_path__ + "svg/calendar/2027/5/junio.svg?e36d9c63";